import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';
import LocalizedMessage from 'react-l10n';
import useFormState from '../../FormStateHelper';
import { validateForm } from '../../../selectors/defaultSelectors';
import AddressFormFields from '../../common/AddressFormFields';

function AccountBusinessAddressForm(props) {
    const { initialData, handleFormSubmission, closeForm } = props;
    const {
        formData,
        updateFormData,
        bindUpdateFormData,
        isSubmitting,
        submitForm,
    } = useFormState({
        handleFormSubmission: handleFormSubmission,
        initialFormState: {
            Country: window.localeCountry,
        },
    });
    const [isValidated, setIsValidated] = useState(false);
    let fieldRefs = {};

    const finalFormData = {
        ...initialData,
        ...formData,
    };

    const onFormSubmit = (e) => {
        e.preventDefault();
        submitForm(finalFormData, {
            success: () => {
                if (closeForm) {
                    closeForm();
                }
            },
        });
    };

    const onFieldUpdate = (e) => {
        bindUpdateFormData(e);
    };

    // Effects
    // --------------------
    // - Validate form
    useEffect(() => {
        setIsValidated(!validateForm(fieldRefs));
    }, [finalFormData]);

    return (
        <React.Fragment>
            <form className='form' onSubmit={onFormSubmit}>
                <div className='vspace vspace--small'>
                    <AddressFormFields
                        defaultIsRequired={true}
                        fieldRefs={fieldRefs}
                        formData={finalFormData}
                        updateField={updateFormData}
                        onFieldUpdate={onFieldUpdate}
                        alwaysDisplayDetailedForm={true}
                    />
                </div>


                <div className='row row--vcenter'>
                    <div className='col-xs-6'>
                        <button
                            type='submit'
                            className={`form__submit button ${!isValidated ? 'button--disabled' : ''
                                }`}
                            disabled={!isValidated}
                        >
                            <span
                                style={{
                                    opacity: isSubmitting === true ? 0 : 1,
                                }}
                            >
                                <LocalizedMessage id={'SAVE'} />
                            </span>
                            {isSubmitting === true && (
                                <ReactLoading
                                    className='button__spinner'
                                    type='spin'
                                    color='white'
                                    height={20}
                                    width={20}
                                />
                            )}
                        </button>
                    </div>

                    {
                        !!closeForm &&
                        <div className='col-xs-6 tx-right'>
                            <button
                                type='button'
                                className='button button--transparent'
                                onClick={() => closeForm()}
                            >
                                <span>
                                    <LocalizedMessage id={'CANCEL'} />
                                </span>
                            </button>
                        </div>
                    }

                </div>
            </form>
        </React.Fragment>
    );
}

export default AccountBusinessAddressForm;
